// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"19a17ac6","448":"deb4f404","516":"27d6e97d"}[chunkId] + ".chunk.js";
};